var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9993 1.95756C17.925 2.55485 17.5582 2.97024 17.1476 3.37679C14.1133 6.37984 11.0865 9.39031 8.06151 12.4022C7.63388 12.8278 7.13552 13.0454 6.52945 12.9921C6.1459 12.9585 5.8043 12.8169 5.51424 12.5604C5.47052 12.5216 5.4275 12.482 5.38627 12.441C3.78276 10.8484 2.17854 9.25644 0.577163 7.66166C-0.0594781 7.02764 -0.178915 6.13753 0.266129 5.40991C0.833809 4.48165 2.14299 4.27573 2.96767 4.98852C3.12657 5.12592 3.27231 5.27816 3.42161 5.42615C4.46597 6.46285 5.50997 7.50024 6.55291 8.5387C6.59806 8.58391 6.63147 8.64043 6.67057 8.692C6.69652 8.70048 6.72211 8.70895 6.74806 8.71743C6.78396 8.65668 6.8092 8.58497 6.8579 8.53694C9.51964 5.88816 12.1849 3.24327 14.8452 0.593084C15.2583 0.181586 15.7396 -0.0321101 16.3261 0.00391809C17.16 0.0551346 17.8383 0.671498 17.9701 1.49343C17.9765 1.53264 17.99 1.57079 18 1.60929C17.9993 1.72444 17.9993 1.841 17.9993 1.95756Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.69a343685fc8d35a0529668999544351.svg";
export { ForwardRef as ReactComponent };